import React from 'react'

export default (props) => {
  const {
    isChecked,
    onChange,
    label,
    isLink,
    onLinkClick,
    idName,
    squareShape,
    labelBeforeCheckInput,
    subText,
    disabled = false
  } = props

  return (
    <div className={`checkbox-wrapper checkbox-wrapper--is-margin-top-15px checkbox-wrapper--is-margin-bottom-15px ${subText && 'checkbox-wrapper--has-subtext'}`}>
      
      {labelBeforeCheckInput && label && 
        <label className={`form-label form-label--is-thin form-label--14px form-label--inverted-styles ${ isLink ? '' : 'form-label--is-max-width'} form-label--no-margin-top`} htmlFor={idName}>
          {
            isLink ?
              <u
                className="terms-and-conditions-link"
                onClick={onLinkClick}>
                {label}
              </u>
              :
              label
          }
          {subText && (
            <>
              <br/>
              {subText}
            </>)}
        </label>
      }
      
      <input
        className={`checkbox checkbox--is-bordered checkbox--is-large ${!squareShape && 'checkbox--round'} checkbox--is-no-margin`}
        id={idName ?? ''}  // Was "checkbox-numberplate" which gives all checkboxes the same id
        name={idName}
        type="checkbox"
        checked={isChecked}
        disabled={disabled}
        onChange={onChange}
      />

      {!labelBeforeCheckInput && label && 
        <label
          className={
            `form-label
            form-label--is-thin
            form-label--14px
            form-label--margin-right-20px
            ${ isLink ? '' : 'form-label--is-max-width'} form-label--no-margin-top`} 
            htmlFor={idName}
          >
          {
            isLink ?
              <u
                className={
                  `terms-and-conditions-link
                  ${disabled && 'terms-and-conditions-link--is-disabled'}`
                }
                onClick={onLinkClick}>
                {label}
              </u>
              :
              label
          }
          {subText && (
            <>
              <br/>
              {subText}
            </>)}
        </label>
      }

    </div>
  )
}
